/**
 * @param   {HTMLElement}  element
 * @returns {?HTMLElement}
 */
export default function getRelativeParent(element) {
  if (element) {
    const position = window
      .getComputedStyle(element)
      .getPropertyValue("position");

    if (position !== "static") {
      return element;
    }
    return getRelativeParent(element.parentElement);
  }

  return null;
}
